/**
 * Tutorial guidato delle Schede aggiuntive dei prodotti.
 *
 * Il menu dei tre pallini si racconta illuminando il pulsante e non la voce dentro
 * il menu: un menu di Vuetify aperto dal tutorial si richiude da solo, perche' il
 * click programmatico e quello su "Avanti" arrivano a `document` a un soffio di
 * distanza.
 */
const SCOPE = '[data-tour-scope="setting-additional-tabs"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createAdditionalTabsTourSteps() {
	return [
		{
			body: "Le schede aggiuntive sono i riquadri di testo in piu' che compaiono nella pagina prodotto del sito, sotto la descrizione: modo d'uso, ingredienti, garanzia. Qui si decide quali esistono; il contenuto si scrive poi prodotto per prodotto.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le schede aggiuntive',
		},
		{
			body: "Da qui si apre la scheda per crearne una nuova: il nome va scritto per ogni lingua, perche' e' il titolo che il cliente legge sul sito.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungerne una',
		},
		{
			body: "La tabella mostra il nome nella lingua del gestionale, l'interruttore di stato e la posizione - cioe' l'ordine con cui i riquadri compaiono nella pagina prodotto.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende e spegne la scheda su tutto il catalogo, e salva subito. Spenta, il riquadro sparisce da tutte le pagine prodotto ma i testi gia' scritti nei prodotti restano dove sono: riaccendendola tornano.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Accendere una scheda',
		},
		{
			body: 'I tre pallini a inizio riga aprono Modifica ed Elimina per quella scheda. Eliminandola sparisce dalle pagine prodotto insieme ai testi che i prodotti avevano dentro.',
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
	];
}
